import { css } from "styled-components";

import { TEXT_PRIMARY } from "../../colors";

export const baseTextStyles = css`
  -webkit-font-smoothing: antialiased;
  color: ${TEXT_PRIMARY};
  font-family: "Source Sans Pro", Helvetica, Arial, Geneva, sans-serif;
  margin: 0;
  text-transform: none;
`;
